import { render, staticRenderFns } from "./modalPagarComision.vue?vue&type=template&id=2f8b7ec3&scoped=true&"
import script from "./modalPagarComision.vue?vue&type=script&lang=js&"
export * from "./modalPagarComision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b7ec3",
  null
  
)

export default component.exports